import React, { useState, useEffect } from "react";
import { DateRange, FilterButtonGroup } from "@design-system";
import { DatePicker } from "../date-picker";
import dayjs, { Dayjs } from "dayjs";
import { RangeValue } from "rc-picker/lib/interface";
import filterStyles from "../../design-system/components/filter/filter.module.css";

export type DateRangeFilterProps = {
  defaultValue?: DateRange;
  onApplyFilter: (value: DateRange) => void;
  onClearFilter: () => void;
};

const { RangePicker } = DatePicker;
const DATE_FORMAT = "DD/MM/YYYY"; // TODO: Add to settings?

const {
  ["filter-dropdown"]: filterDropdownClassName,
  ["filter-content"]: filterContentClassName,
  ["date-picker"]: datePickerClassName,
} = filterStyles;

export const DateRangeFilter = ({
  defaultValue,
  onApplyFilter,
  onClearFilter,
}: DateRangeFilterProps) => {
  const [canApply, setCanApply] = useState(false);
  const [value, setValue] = useState(defaultValue || {});
  const { from, to } = value;

  const onClickApply = () => {
    onApplyFilter && onApplyFilter(value);
    setCanApply(false);
  };

  const onClickClear = () => {
    onClearFilter && onClearFilter();
    setValue({});
    setCanApply(false);
  };

  const onChange = (dates: RangeValue<Dayjs>) => {
    const from = dates && dates[0] !== null ? dates[0] : undefined;
    const to = dates && dates[1] !== null ? dates[1] : undefined;
    const newValue: DateRange = {
      from: from?.toDate(),
      to: to?.toDate(),
    };
    setValue(newValue);
    setCanApply(true);
  };

  useEffect(() => {
    setValue(defaultValue || {});
  }, [defaultValue]);

  return (
    <div className={filterDropdownClassName}>
      <FilterButtonGroup
        canApply={canApply}
        canClear={!!(from || to)}
        onClickApply={onClickApply}
        onClickClear={onClickClear}
      />
      <div className={filterContentClassName}>
        <div className={datePickerClassName}>
          <RangePicker
            allowClear={false}
            allowEmpty={[true, true]}
            bordered={false}
            value={[from ? dayjs(from) : null, to ? dayjs(to) : null]}
            format={DATE_FORMAT}
            onChange={onChange}
            placeholder={["Start date", "End date"]}
            popupClassName={filterDropdownClassName}
          />
        </div>
      </div>
    </div>
  );
};
